module.exports = __webpack_public_path__ + "img/greytotquestions.611262b5.svg";